import { Box, ListItemButton } from "@mui/material";
import MuiImage from "mui-image";
import { useContext } from "react";
import { ConnectedEntity } from "src/types/apps";
import { entitiesUrl } from "src/utils/formatUrl";

import Context from "../../context";

// ----------------------------------------------------------------------

type Props = {
	item: ConnectedEntity;
};

const sx = {
	borderRadius: 1,
	m: 1,
	p: 4,
	justifyContent: "center",
	cursor: "pointer",
	boxShadow: 2
};

export const EntityItemBtn = ({ item }: Props) => {
	const { actions } = useContext(Context);

	return (
		<ListItemButton key={item.id} onClick={() => actions.onSelectEntity(item)} sx={sx}>
			<Box
				height={35}
				sx={{
					display: "flex",
					overflow: "hidden",
					alignItems: "center",
					justifyContent: "center"
				}}
			>
				<MuiImage
					src={entitiesUrl(item.id)}
					alt={item.name}
					fit='contain'
					duration={500}
					height='auto'
				/>
			</Box>
		</ListItemButton>
	);
};

export default EntityItemBtn;
